import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SelectInput } from '@interstate/components/SelectInput';
import * as interactionAnalyticsActionCreators from '@makemydeal/dr-dash-store/actions/interactionAnalyticsActionCreators';
import * as offerReduxSelectors from '@makemydeal/dr-dash-store/selectors/offerRedux';
import * as offerReduxActionCreators from '@makemydeal/dr-dash-store/actions/offerRedux';
import { FINANCE, LEASE } from '@makemydeal/dr-platform-types';

import { dealLockHooks } from '../../hooks';
import { CREDIT_DECISION_STATUS } from '../../constants';

const CreditDecisionStatusField = () => {
    const dispatch = useDispatch();
    const creditDecisionStatus = useSelector(offerReduxSelectors.getCreditDecisionStatus);
    const options = ['None', 'Approved', 'ConditionallyApproved', 'Declined', 'Pending'].map((t) => ({ value: t, label: t }));
    const offerType = useSelector(offerReduxSelectors.getCurrentOfferType);
    const isLocked = dealLockHooks.useIsDealLocked();

    const handleOfferType = () => {
        if (offerType === FINANCE) dispatch(interactionAnalyticsActionCreators.financeLenderDecisionDropdown());
        else if (offerType === LEASE) dispatch(interactionAnalyticsActionCreators.leaseLenderDecisionDropdown());
    };

    return (
        <SelectInput
            size="sm"
            data-testid={'lender-decision-status'}
            id="CreditDecisionStatusField"
            label={CREDIT_DECISION_STATUS}
            name={CREDIT_DECISION_STATUS}
            onChange={(event) => {
                const action = offerReduxActionCreators.updateCreditDecisionStatus(event.target.value as string);
                dispatch(action);
                handleOfferType();
            }}
            value={creditDecisionStatus}
            disabled={isLocked}
            options={options}
            displayDeselectOption={false}
        />
    );
};

export default CreditDecisionStatusField;
